export default __webpack_public_path__ + "static/truck-ud-trucks-a7300478e44f9118bd75145226d0d18a.png";